import Badge from './badge';
import Driver from './driver';
import Poin from './poin';
import Pending from './pending';
import Contact from './contact';
import Partner from './partner';
import Vending from './vending-machine';
import Payment from './payment';
import User from './user';

const Cards = {
  Driver,
  Badge,
  Poin,
  Pending,
  Contact,
  Partner,
  Vending,
  Payment,
  User,
};

export default Cards;
